import { FunctionComponent } from 'react'
import useStyles from '@/modules/Auth/components/UserProfileCard/styles'
import { Avatar, Box, Text } from '@conexasaude/conexa-hero'
import Icon from '@/components/HeroIcons'

interface PropsUserProfileCard {
  className?: string
  name: string
  busy: boolean
  token: string
  clinic: string
  photo: string
  type: string
  onClick(): void
  onActionClick(): void
}

const UserProfileCard: FunctionComponent<PropsUserProfileCard> = ({
  onClick,
  className,
  busy,
  name,
  onActionClick,
  clinic,
  photo,
}) => {
  const styles = useStyles()

  return (
    <div className={className} css={styles.userProfileCard}>
      <Box background="primary">
        <div css={styles.itemsCard}>
          <div css={styles.avatarCard}>
            <Avatar alt={name} size="medium" src={photo} />
          </div>
          <div css={styles.textCard}>
            <Text
              renderAs="h5"
              css={styles.nameCard}
              className="text-capitalize"
            >
              {name.toLowerCase()}
            </Text>
            <div css={styles.clinicCard}>{clinic}</div>
            <div css={styles.specialityCard}>
              <Text renderAs="p" onClick={() => onActionClick()}>
                Ver especialidades disponíveis
              </Text>
            </div>
          </div>
          <div css={styles.iconCard}>
            {busy ? (
              <Icon name="loading" width={'24px'} height={'24px'} />
            ) : (
              <Icon
                name="arrow-group"
                width={'24px'}
                height={'24px'}
                onClick={() => onClick()}
              />
            )}
          </div>
        </div>
      </Box>
    </div>
  )
}

export default UserProfileCard
